import Discord from './Discord'

export default Discord
// eslint-disable-next-line import/export
export * from './Discord'
